export default function initPreloader() {

  setTimeout(() => {

    gsap.to('#preloader-site .preloader-logo', {

      autoAlpha: 0,

      onComplete: () => {

        gsap.to('#preloader-site', {
          autoAlpha: 0,
        });

      },

    });

  }, 600);

}
